export const SCOPE_ITEMS_CSV_FILE_ERROR = "Select a CSV file.";

export const SCOPE_ITEMS_IMPORTED = "Design scope items imported.";

export const SCOPE_ITEMS_IMPORT_ACTION_ERROR = "An error occurred";

export function scopeItemsImportErrorMessage(errorMsg?: string | null): string {
  const text = errorMsg?.trim();
  return text || SCOPE_ITEMS_IMPORT_ACTION_ERROR;
}
